
import {
  Card,
  Button,
  Select,
  Spin,
} from "antd";
import {
  DownloadOutlined,
  ExperimentOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { json2excel } from "js2excel";
import React, { useEffect, useState } from "react";
import { useLazyQuery, useQuery } from "@apollo/react-hooks";
import uniq from "lodash/uniq";
import moment from "moment";

import { meteorologyTypes } from "@constants/AppConstants";
import { getCampaignsQuery, getFieldbooksExportQuery } from "@graphql/queries";

const iconStyle = { fontSize: 48, marginBottom: 40 };
const { Option } = Select;

function Pesticides() {
  // Fetch available campaigns/years
  const { loading: loadingCampaigns, data: campaignsData } = useQuery(getCampaignsQuery);
  const availableYears = uniq(
    campaignsData?.campaigns?.map(({ year }) => year)?.sort()
  );

  const [year, setYear] = useState(null);
  const [data, setData] = useState([]);

  // Lazy query for fieldbooks - only runs when year is selected
  const [fetchFieldbooks, { loading: loadingFieldbooks, data: fieldbooksData }] = useLazyQuery(
    getFieldbooksExportQuery,
    {
      variables: { year: year ? String(year) : null },
      skip: !year,
    }
  );

  // Trigger fetch when year changes
  useEffect(() => {
    if (year) {
      fetchFieldbooks();
    } else {
      setData([]);
    }
  }, [year, fetchFieldbooks]);

  // Process fieldbooks data when it arrives
  useEffect(() => {
    const fieldbooks = fieldbooksData?.fieldbooks;
    const generated = [];

    if (fieldbooks) {
      // eslint-disable-next-line no-unused-expressions
      fieldbooks?.map(fieldbook => {
        const producers = fieldbook?.producers;
        const parcel = fieldbook?.parcels[0]?.parcel;

        if (!parcel) return;

        // eslint-disable-next-line no-unused-expressions
        fieldbook.pesticides?.map(pesticide => {
          generated.push({
            Organização: "Provape",
            Produtor: producers
              .map(({ producer }) => producer?.name)
              .join(", "),
            Número: producers
              .map(({ producer }) => producer?.number)
              .join(", "),
            Parcela: parcel.portion?.name,
            Localização: parcel.portion?.location,
            Área: pesticide.area,
            Finalidade: pesticide.product?.activeSubstance?.goal?.name,
            "Data Aplicação": moment(pesticide.date).format("DD-MM-YYYY"),
            "Subs. Activa": pesticide.product?.activeSubstance?.name,
            "Nome Comercial": pesticide.product?.name,
            Fabricante: pesticide.product?.manufacturer?.name,
            "Quantidade / ha": pesticide.product?.dose,
            Unidade: pesticide.product?.unity?.name,
            Calda: pesticide.sauce,
            Meteorologia: meteorologyTypes[pesticide.meteorology],
          });
        });
      });

      setData(generated);
    }
  }, [fieldbooksData]);

  const downloadFile = () => {
    if (data.length > 0) {
      json2excel({
        data,
        name: "Fitofarmacos",
      });
    }
  };

  const isLoading = loadingCampaigns || loadingFieldbooks;

  return (
    <Card title="Fitofármacos" style={{ textAlign: "center" }}>
      <div>
        <ExperimentOutlined style={iconStyle} />
      </div>

      {loadingCampaigns ? (
        <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
      ) : (
        <>
          <Select
            placeholder="Selecione um ano"
            optionFilterProp="children"
            onChange={setYear}
            value={year}
            disabled={availableYears.length === 0}
            style={{ marginRight: 10, minWidth: 150 }}
          >
            {availableYears?.map(year => (
              <Option value={year} key={year}>
                {year}
              </Option>
            ))}
          </Select>

          <Button
            type="primary"
            icon={<DownloadOutlined />}
            onClick={downloadFile}
            disabled={!year || isLoading}
            loading={loadingFieldbooks}
          >
            Exportar {data.length} fitofármacos
          </Button>

          {!year && (
            <div style={{ marginTop: 20, fontSize: 12, color: "#999" }}>
              Selecione um ano para carregar os dados
            </div>
          )}
        </>
      )}
    </Card>
  );
}

export default Pesticides;
